SystemJS.config({
    map: {
        'plugin-babel': 'plugin-babel.js',
        'systemjs-babel-build': 'systemjs-babel-browser.js'
    },
    transpiler: 'plugin-babel'
});